export default __webpack_public_path__ + "static/media/fire.bf020eab.svg";